const appModeState = import.meta.env.VITE_APP_MODE;

// BE
export const baseUrl =
  appModeState === 'local'
    ? `${import.meta.env.VITE_APP_BASE_URL_LOCAL}`
    : appModeState === 'development'
      ? `${import.meta.env.VITE_APP_BASE_URL_DEV}`
      : appModeState === 'uat'
        ? `${import.meta.env.VITE_APP_BASE_URL_UAT}`
        : appModeState === 'production'
          ? `${import.meta.env.VITE_APP_BASE_URL_PROD}`
          : 'need-to-set-app-mode';

export const webUrl =
  appModeState === 'local'
    ? `${import.meta.env.VITE_APP_WEB_URL_LOCAL}`
    : appModeState === 'development'
      ? `${import.meta.env.VITE_APP_WEB_URL_DEV}`
      : appModeState === 'uat'
        ? `${import.meta.env.VITE_APP_WEB_URL_UAT}`
        : appModeState === 'production'
          ? `${import.meta.env.VITE_APP_WEB_URL_PROD}`
          : 'need-to-set-app-mode';

// API
export const key = `${import.meta.env.VITE_APP_KEY}`;
export const iv = `${import.meta.env.VITE_APP_IV}`;
export const rtkKey = `${import.meta.env.VITE_APP_RTK_KEY}`;

// GOOGLE RECAPTCHA
export const googleReKey =
  appModeState === 'production'
    ? `${import.meta.env.VITE_APP_GOOGLE_RE_KEY_PROD}`
    : appModeState === 'uat'
      ? `${import.meta.env.VITE_APP_GOOGLE_RE_KEY_UAT}`
      : appModeState === 'development'
        ? `${import.meta.env.VITE_APP_GOOGLE_RE_KEY_DEV}`
        : 'need-to-set-app-mode';

// MODE
export const appMode: 'production' | 'local' | 'development' | 'uat' = `${
  import.meta.env.VITE_APP_MODE
}` as 'production' | 'local' | 'development' | 'uat';

export const isAppOnLocal = import.meta.env.VITE_APP_MODE === 'local';

// EXCHANGE_RATE
export const exchangeRateKey = `${import.meta.env.VITE_APP_EXCHANGE_RATE_KEY}`;

// GOOGLE MAPS API
export const googleMapsKey = `${import.meta.env.VITE_APP_GOOGLE_MAPS_API.replace(
  `'`,
  '',
)}`;
